export default "__VITE_ASSET__CGQIAxGM__"